import { useProfileContext } from '@/contexts/profile';
import { TAdminRoles } from '@/types.ts';

export const useRoleAccess = (): ((roles: TAdminRoles[] | undefined) => boolean) => {
    const { role } = useProfileContext();

    return (roles) => (role ? (roles || []).includes(role) : false);
};
